/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wacky_Helpful_Anaconda_FearInputs */

const fr_wacky_helpful_anaconda_fear = /** @type {(inputs: Wacky_Helpful_Anaconda_FearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur est survenue lors du chargement des WODs.`)
};

/**

* @param {Wacky_Helpful_Anaconda_FearInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const wacky_helpful_anaconda_fear = /** @type {((inputs?: Wacky_Helpful_Anaconda_FearInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wacky_Helpful_Anaconda_FearInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_wacky_helpful_anaconda_fear(inputs)
});